<template>
    <div
        ref="filterWrapper"
        class="search-panel__filter"
    >
        <form
            ref="form"
            action="/"
            method="post"
            class="search-panel__filter-form"
            @change="emitSend"
        >
            <div class="search-panel__filter-items">
                <div
                    class="search-panel__filter-item"
                    v-for="(filter, index) in filters"
                    :key="index"
                >
                    <RadioButtons
                        v-if="isRadioFilter(filter.type)"
                        :filter="filter"
                        class="search-panel__radio-buttons"
                        @change="debouncedEmitSend"
                    />

                    <RangeSlider
                        v-if="isSliderFilter(filter.type)"
                        :slider="filter"
                        :translations="data.settings.translations.form"
                        @change="debouncedEmitSend"
                        class="search-panel__range-slider"
                    />

                    <div
                        v-if="isCheckboxFilter(filter.type)"
                        class="search-panel__form-input"
                    >
                        <CheckboxItem
                            v-for="item in filter.items"
                            :key="item.id"
                            :title="item.title"
                            :name="`${filter.category}[${item.id}]`"
                            :value="`${item.id}`"
                            :checked="item.checked"
                            :disabled="item.disabled"
                            modify="checkbox_theme_block"
                        />
                    </div>
                </div>
            </div>

            <div class="search-panel__result-button">
                <ResultButton
                    v-if="!isEmpty(link)"
                    :link="link"
                />
            </div>
        </form>
    </div>
</template>

<script>
import CheckboxItem from '../CheckboxItem/CheckboxItem.vue';
import RadioButtons from '../RadioButtons/RadioButtons.vue';
import RangeSlider from '../RangeSlider/RangeSlider.vue';
import ResultButton from '../ResultButton/ResultButton.vue';
import {Utils} from '../../../common/scripts/utils';

export default {
    props: ['data'],

    data() {
        return {
            debouncedEmitSend: null
        };
    },

    components: {
        CheckboxItem,
        RadioButtons,
        RangeSlider,
        ResultButton,
    },

    computed: {
        filters() {
            return this.data.filters || null;
        },

        link() {
            return this.data.link || null;
        },

        isRent() {
            const saleTypeFilter = this.data.filters.find(filter => filter.category === 'saleType');

            return saleTypeFilter?.items?.[1]?.checked;
        },
    },

    created() {
        this.debouncedEmitSend = Utils.debounce(() => {
            this.$emit('changeFilter', this.$refs.form);
        }, 300);
    },

    methods: {
        toggleFilter() {
            if (this.isPanelOpen) {
                this.closeFilter();
            } else {
                this.openFilter();
            }
        },

        openFilter() {
            this.$emit('openFilter');
        },

        closeFilter() {
            this.$emit('closeFilter');
        },

        /**
         * При изменении фильтра,
         * отправляем данные на бэк
         */
        emitSend() {
            this.$emit('changeFilter', this.$refs.form);
        },

        /**
         * Проверяет объект на пустоту
         * @param {Object} obj - проверяемый объект
         * @return {boolean|boolean} - true, если пустой
         */
        isEmpty(obj) {
            if (!obj) {
                return true;
            }

            return Object.keys(obj).length === 0 && obj.constructor === Object;
        },

        isCheckboxFilter(type) {
            return type === 'checkbox';
        },

        isSliderFilter(type) {
            return type === 'slider';
        },

        isSelectFilter(type) {
            return type === 'select';
        },

        isRadioFilter(type) {
            return type === 'radio';
        }
    }
};
</script>
